import partsMixin from '../_parts_mixin';
import commonMixin from '../../../mixins/_common';
import flashMessageMixin from '../../../mixins/_flash_messages';
import captureMixin from '../../../mixins/_capture';
import imagesConfigMixin from '../../../mixins/_images_config';
import loop from '../../../components/_loop-component';
import imageSelecter from '../../../components/_image_selecter';

/**
 * パーツ編集コンポーネント「ヘッダー」
 */
export default {
    template: '#parts_edit_header_template',
    data() {
        return {
            static_html: '', //看板デザインの静的HTML
            isCapture: false //キャプチャ進行中フラグ
        };
    },
    props:[
        'parts_data',
        'type',
        'edit_id',
        'device_sync',
    ],
    mixins: [
        commonMixin,
        flashMessageMixin,
        partsMixin,
        captureMixin,
        imagesConfigMixin
    ],
    components: {
        // ループコンポーネント
        'loop': loop,
        // 画像選択コンポーネント
        'image-selecter': imageSelecter,
    },
    methods: {
        /**
         * 現在の看板設定から一枚の看板画像を生成する
         */
        createCapture: async function () {
            // パーツタイプがもともとimageなら何もしない
            if (this.parts_data.type === 'image') {
                return;
            }

            // 静的HTMLを生成してプレビューを作成
            await this.setStaticHtml();

            try {
                this.$_loading();
                this.isCapture = true;

                // DOM側が描画されてからキャプチャ
                await this.$nextTick();
                var file = await this.capture('#capture_preview');

                // 完成したキャプチャをストクリにアップロード
                var imageSelecter = this.$refs.mainImageSerecter;
                await imageSelecter.uploadFormData(file);

                // 看板設定を切替
                this.parts_data.type = 'image';
            } finally {
                this.isCapture = false;
                this.$_unloading();
            }
        },
        /**
         * 看板データを元に静的HTMLを取得
         * 
         */
        setStaticHtml: async function () {
            this.$_loading();
            let message = this.exception_error_message;

            // 送信用にデータ調整
            let data = {};
            data['data'] = await this.changeImagePath();
            data['key'] = 'header';

            try {
                const response = await axios.post('/build_store/get_kanban_html', {
                    edit_id: this.edit_id,
                    data:    data,
                });
                if (response.data.status === 'OK') {
                    this.static_html = response.data.data;
                    // エラーメッセージを空にする
                    message = '';
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            } finally {
                this.$_unloading();
            }
            
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }
        },
        /**
         * 画像データを絶対パスに変換
         * (サーバ側で絶対パスからBase64エンコードURLを生成するため)
         * 
         * @return {Object} data 画像パスが変換されたパーツ設定データ
         */
        changeImagePath: async function () {
            // オブジェクトをコピー
            const data = Object.assign({}, this.parts_data);
            // ロゴ画像
            data.logo_image = this.getImageFullPath(data.logo_image);
            // 背景画像
            data.background_image = this.getImageFullPath(data.background_image);
            // イメージ画像
            data.main.forEach((item) => {
                item.image = this.getImageFullPath(item.image);
            });
            return data;
        },
        // mixinのgetPreviewImagePath()を実行
        getImageFullPath: function (image) {
            if (image === null || image.length < 1) {
                return image; // 空を渡すとnoimage画像になるので終了
            }
            return this.getPreviewImagePath(image, this.edit_id, this.type);
        }
    }
};
